import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Flag = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.768 24.567c2.248.975 4.307 1.165 6.253.9 2.292-.312 4.386-1.256 6.33-2.131l.056-.026c2.006-.903 3.859-1.73 5.842-2.002 1.932-.265 4.027-.003 6.485 1.395a.99.99 0 0 0 1.478-.86V3.024a.99.99 0 0 0-.5-.86C32.878.554 30.344.205 27.98.53c-2.29.314-4.384 1.258-6.327 2.134l-.06.027c-2.005.904-3.858 1.732-5.84 2.004-1.933.265-4.028.002-6.485-1.395a.99.99 0 0 0-1.479.86v39.27a.99.99 0 1 0 1.98 0V24.567Zm0-18.806c2.248.973 4.308 1.161 6.253.895 2.291-.314 4.384-1.258 6.327-2.134l.06-.027c2.005-.904 3.858-1.732 5.84-2.004 1.8-.247 3.742-.036 5.985 1.123v16.627c-2.248-.973-4.307-1.16-6.253-.894-2.29.313-4.382 1.256-6.323 2.13l-.063.029c-2.006.903-3.858 1.73-5.84 2-1.8.245-3.742.032-5.986-1.13V5.76Z"
  }));
});
Flag.displayName = 'Flag';
Flag.defaultProps = {
  'aria-label': 'Flag'
};
export default Flag;